import React from "react";

import { faInfoCircle } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import Cropper from "cropperjs";

import { Button } from "~/ui";
import { Modal } from "~/ui/legacyFellowIndex";
import { default as ReactCropper } from "~/vendor/react-cropper";

import styles from "./css/ImageCropper.module.css";

interface ImageCropperProps {
	close: () => void;
	aspectRatio: number;
	handleCanvasReady: () => void;
	circular: boolean;
	handleCropperRef: (cropper: Cropper) => void;
	src: string | undefined;
	handleCropperCancel: (close: () => void) => void;
	handleCropperDone: (close: () => void) => void;
}

const dialogWidth = 550;
const dialogHeight = 400;

export default function ImageCropper({
	close,
	aspectRatio,
	handleCanvasReady,
	circular,
	handleCropperRef,
	src,
	handleCropperCancel,
	handleCropperDone,
}: ImageCropperProps) {
	const onCancelClick = React.useCallback(() => {
		handleCropperCancel(close);
	}, [handleCropperCancel, close]);

	const onDoneClick = React.useCallback(() => {
		handleCropperDone(close);
	}, [handleCropperDone, close]);

	return (
		<Modal onClose={onCancelClick}>
			<Modal.Header onClose={onCancelClick}>
				<Modal.Title>Preview</Modal.Title>
			</Modal.Header>
			<Modal.Body style={{ boxSizing: "content-box", maxHeight: dialogHeight }}>
				<ReactCropper
					guides
					highlight
					background
					modal
					responsive
					toggleDragModeOnDblclick
					checkCrossOrigin
					className={cx({ [styles.circularCropper]: circular })}
					maxContainerWidth={dialogWidth}
					maxContainerHeight={dialogHeight}
					ref={handleCropperRef}
					src={src}
					viewMode={0}
					dragMode="move"
					aspectRatio={aspectRatio}
					ready={handleCanvasReady}
				/>
				<p className={styles.infoText}>
					<FontAwesomeIcon icon={faInfoCircle} />
					Scroll to resize the image frame
				</p>
			</Modal.Body>
			<Modal.Footer>
				<Button size="normal" onClick={onCancelClick}>
					Cancel
				</Button>
				<Button variant="primary" size="normal" onClick={onDoneClick}>
					Done
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
